import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="w-2 h-2 rounded-full bg-accent-500 inline-block mr-2"></span>
          <span className="text-foreground-400 text-xs font-medium tracking-wider uppercase">
            读者评价
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-3">
            用户口碑
            <br />
            真实反馈
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">
            听听数百万读者怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-6 flex flex-col"
            >
              <div className="flex gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h4 className="font-heading font-semibold text-foreground-950 text-sm mb-2">
                {item.content.slice(0, 20)}...
              </h4>
              <p className="text-foreground-600 text-xs leading-relaxed flex-1 mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-background-200/70">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}